//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import regionSeatLibs from 'utils/regionSeatLibs'
let regionData = JSON.parse(JSON.stringify(regionSeatLibs[0].c))
import { workTypeTree,workServiceList,reservationServer } from "@/api/gxInfo" 
export default {
  // props:{
  //   workDemandId:{
  //     type:String,
  //     default:''
  //   }
  // },
  data(){
    return {
      visible:false,
      workDemandId:'',//
      regionData,
      props: {
        value: 'i',
        label: 'n',
        children: 'c'
      },
      workTypeTree:[],//作业类型数据
      workTypeProps:{
        value: 'code',
        label: 'name',
        children: 'children'
      },
      filterForm:{
        checkedWorkArea:[],//作业地区，
        checkedWorkType:[],//作业类型
      },
      tableData:[],
      pagination: {
        pageNum: 1,
        pageSize: 10,
        total: 0,
      },
      checkedData:[],//选中的表格数据
      loading:false,

    }
  },
  watch:{
    visible:{
      handler(val){
        if(val){
          this.handleFilter(1);
        }else{
          this.$refs.filterForm.resetFields();
          this.tableData = [];
          this.checkedData = [];
        }
      }
    }
  },
  created(){
    this.getWorkTypes();
  },
  methods:{
    init(workDemandId){
      this.visible = true;
      this.workDemandId = workDemandId;
    },
    /**
     * @Author: likk
     * @description: 获取作业类型
     * @param {*}
     * @return {*}
     */ 
    async getWorkTypes(){
      let { data: {result} } = await workTypeTree();
      this.workTypeTree = result || [];
     
    },  
    /**
     * @Author: likk
     * @description: 查询
     * @param {Number} page 页码
     * @return {*}
     */ 
    handleFilter(page=1){
      this.pagination.pageNum = page
      this.getList();
    },  
    /**
     * @Author: likk
     * @description: 获取作业服务列表
     * @param {*}
     * @return {*}
     */ 
    async getList(){
      try {
        this.loading = true;
        let { checkedWorkType,checkedWorkArea } = this.filterForm;
        let {data}  = await workServiceList({
          workType:checkedWorkType[checkedWorkType.length-1],
          workProvinceId:checkedWorkArea[0] || '',
          workCityId:checkedWorkArea[1] || '',
          workCountyId:checkedWorkArea[2] || '',
          workDemandId:this.workDemandId,
          currentPage:this.pagination.pageNum,
          pageSize:this.pagination.pageSize
        });
        this.loading = false;
        this.tableData = data.content;
        this.pagination.total = data.recordTotal;
        // // 默认选中
        // this.$nextTick(() => {
        //   let checkedIds = this.checkedData.map( item => item.id);
        //   this.tableData.forEach(row => {
        //     if(checkedIds.includes(row.id)){
        //       console.log("m默认选中-row",row.ownerName)
        //       this.$refs.multipleTable.toggleRowSelection(row,true);
        //     }
        //   });
        // })
        
      } catch (error) {
        console.log(error);
        this.loading = false;
      }
    },   
    getRowKey(row){
      return row.id
    },
    /**
     * @Author: likk
     * @description: 多选
     * @param {*}
     * @return {*}
     */      
    handleSelectionChange(val){
      this.checkedData = val
    },
    /**
     * @Author: likk
     * @description: 表格数据是否可勾选
     * @param {*}
     * @return {*}
     */
     handleSelectable(row){
        return (row.isReservation!=1 ? true : false);
     },      
    /**
     * @Author: likk
     * @description: 查看
     * @param {*}
     * @return {*}
     */  
    handleDetail(id){
      this.$router.push({
        path:'/gx-query/service/detail',
        query:{id}
      })
    },
    /**
     * @Author: likk
     * @description: 发布
     * @param {*}
     * @return {*}
    */    
    handleSubmit(){
      let params = this.checkedData.map( item => {
        return {
          workServerId:item.id,
          workDemandId:this.workDemandId,
          owerUserId:item.ownerId
        } 
      })
      reservationServer({data:params}).then( () => {
        this.$message.success('预约成功');
        this.visible = false;
        this.$emit("onSuccess")
      })
    },
  }
}
